import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=43f26a26&"
import script from "./Register.vue?vue&type=script&lang=ts&"
export * from "./Register.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseRadio: require('/home/vsts/work/1/a/NuxtApp/components/base/Radio.vue').default,BaseFormItem: require('/home/vsts/work/1/a/NuxtApp/components/base/FormItem.vue').default,BaseInput: require('/home/vsts/work/1/a/NuxtApp/components/base/Input.vue').default,BaseSelect: require('/home/vsts/work/1/a/NuxtApp/components/base/Select.vue').default,BaseCheckbox: require('/home/vsts/work/1/a/NuxtApp/components/base/Checkbox.vue').default,BaseForm: require('/home/vsts/work/1/a/NuxtApp/components/base/Form.vue').default,AppNoty: require('/home/vsts/work/1/a/NuxtApp/components/app/Noty.vue').default,BaseButton: require('/home/vsts/work/1/a/NuxtApp/components/base/Button.vue').default})
